module.exports = __webpack_public_path__ + "static/media/pencil.46513774.png";